import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import AddonsPage from "./AddonsPage";
import { setAddonsModal } from "../../API/Reducer/fabricReducer";

const AddonsModal = () => {
  const dispatch = useDispatch();
  const { addonsModal } = useSelector((state) => state.fabric);
  return (
    <Modal show={addonsModal} 
    onHide={() => {dispatch(setAddonsModal(false));}}
     size="lg" centered backdrop="static">
      <Modal.Body style={{ position: "relative", padding: "1rem" }}>
        {/* Close Icon */}
        <div
          onClick={() => {dispatch(setAddonsModal(false));}}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#555",
          }}
          title="Close"
        >
          <IoClose />
        </div>

        {/* Table */}
        <AddonsPage />
      </Modal.Body>
    </Modal>
  );
};

export default AddonsModal;
